"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _vaul = require("vaul");
var _variables = require("../../../styles/variables");
var _colors = _interopRequireDefault(require("../../../styles/colors"));
var _HBColorPickerDrawerHeader = _interopRequireDefault(require("./HBColorPickerDrawerHeader"));
var HBColorPickerDrawer = function HBColorPickerDrawer(_ref) {
  var isOpen = _ref.isOpen,
    onSave = _ref.onSave,
    onClose = _ref.onClose,
    className = _ref.className,
    parent = _ref.parent,
    title = _ref.title,
    testId = _ref.testId,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_vaul.Drawer.Root, {
    open: isOpen,
    dismissible: false
  }, /*#__PURE__*/_react["default"].createElement(_vaul.Drawer.Portal, {
    container: parent
  }, /*#__PURE__*/_react["default"].createElement(DrawerContentContainer, {
    className: className,
    onEscapeKeyDown: onClose,
    onPointerDownOutside: onClose
  }, /*#__PURE__*/_react["default"].createElement(_HBColorPickerDrawerHeader["default"], {
    onSave: onSave,
    onClose: onClose,
    title: title,
    testId: testId
  }), /*#__PURE__*/_react["default"].createElement(Content, null, children))));
};
var _default = exports["default"] = HBColorPickerDrawer; // -------------------------------- Styles -------------------------------- //
var DrawerContentContainer = (0, _styledComponents["default"])(_vaul.Drawer.Content).withConfig({
  displayName: "HBColorPickerDrawer__DrawerContentContainer",
  componentId: "sc-hqsie-0"
})(["position:fixed;bottom:0;inset-inline:0;z-index:", ";max-height:90%;background:", ";border-radius:0 8px 0 8px;"], _variables.Z_INDEX.POPOVER, _colors["default"].white);
var Content = _styledComponents["default"].section.withConfig({
  displayName: "HBColorPickerDrawer__Content",
  componentId: "sc-hqsie-1"
})(["padding:20px 16px 40px;background:", ";position:relative;"], _colors["default"].white);
//# sourceMappingURL=HBColorPickerDrawer.js.map